import React, { useContext, useEffect, useState, Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import ModalTakeDecision from '../dealerReceptor/ModalTakeDecision';
import ModalNegotiateVehicle from '../dealerReceptor/ModalNegotiateVehicle';
import ModalRejectVehicle from '../dealerReceptor/ModalRejectVehicle';
import ModalSellVWRVehicle from '../dealerReceptor/ModalSellVWRVehicle';
import { disableHTMLOverflow } from '../../Functions';
import Globals from '../../Globals';

function DealerReceptorDecisions({ history, closeModal }) {
    const {
        setSelectedVehicle,
        selectedVehicle,
        setContextListVehicles,
        contextListVehicles,
    } = useContext(VehiclesContext);
    const [possibleActions, setPossibleActions] = useState([]);
    const [showTakeDecision, setShowTakeDecision] = useState(false);
    const [showReject, setShowReject] = useState(false);
    const [showNegotiation, setShowNegotiation] = useState(false);
    const [showSellVWR, setShowSellVWR] = useState(false);

    useEffect(() => {
        disableHTMLOverflow(true);
        if (!selectedVehicle) closeThisModal();
        updateActionToDo();
    }, []);

    const updateActionToDo = () => {
        let actions = [];

        if(selectedVehicle.AutoCredit==0)
        {
        
            if (
                (selectedVehicle.RepurchaseObligation == 0 &&
                    selectedVehicle.AcceptedWithReport == 1) ||
                (selectedVehicle.IsReturnDealerPromoter == 0 &&
                    selectedVehicle.RepurchaseObligation == 1 &&
                    selectedVehicle.AcceptedWithReport == 1)
            ) {
                //CPC - Penalización (Comprar y desestimar)
                actions = ['Buy', 'Reject'];
            } else if (
                (selectedVehicle.RepurchaseObligation == 0 &&
                    selectedVehicle.AcceptedWithReport == 0) ||
                (selectedVehicle.IsReturnDealerPromoter == 0 &&
                    selectedVehicle.RepurchaseObligation == 1 &&
                    selectedVehicle.AcceptedWithReport == 0)
            ) {
                //CPC - Penalización (Comprar y desestimar)
                actions = ['Buy'];
            } else if (selectedVehicle.RepurchaseObligation == 2) {
                //Renting (Comprar, negociar y desestimar)
                actions = ['Buy', 'Negotiate', 'Reject'];
            }
        }
        else
        {
            //Renting (Comprar, negociar y desestimar)
            if (selectedVehicle.AcceptedWithReport == 1 && selectedVehicle.PhysicalClient)
            {
                actions = ['BuyAutoCredit', 'SellRenting'];
            }
            else if(selectedVehicle.AcceptedWithReport == 1 && !selectedVehicle.PhysicalClient && selectedVehicle.InvoiceClientDealerUploaded)
            {
                actions = ['BuyAutoCredit', 'SellRenting'];
            } 
            else
            {
                actions = ['BuyAutoCredit'];
            } 
        }
        if (actions.length > 0) {
            setPossibleActions(actions);
            setShowTakeDecision(true);
        } else {
            closeThisModal();
        }
    };

    const onClickGoToDirectPurchase = () => {
        disableHTMLOverflow(false);
        history.push(Globals.APPLICATION_PATH.DIRECT_PURCHASE);
    };

    const closeModalTakeDecision = closeAction => {
        switch (closeAction) {
            case 'Buy':
                onClickGoToDirectPurchase();
                break;
            case 'BuyAutoCredit':
                onClickGoToDirectPurchase();                
                break;
            case 'SellAutoCreditREBU':
                selectedVehicle.SellAutoCreditVWR=true;
                selectedVehicle.SellAutoCreditVWRMode=1;
                onClickGoToDirectPurchase();                
                    break;
            case 'SellAutoCreditREG':
                selectedVehicle.SellAutoCreditVWR=true;
                selectedVehicle.SellAutoCreditVWRMode=2;
                onClickGoToDirectPurchase();
                    break;
            case 'SellRenting':
                setShowTakeDecision(false);
                setShowReject(false);                
                setShowSellVWR(true);
                            break;
            case 'Reject':
                setShowTakeDecision(false);
                setShowReject(true);
                setShowSellVWR(false);
                setShowNegotiation(false);
                break;
            case 'Negotiate':
                setShowTakeDecision(false);
                setShowReject(false);
                setShowSellVWR(false);
                setShowNegotiation(true);
                break;
            case 'Prev':
                setShowTakeDecision(true);
                setShowReject(false);
                setShowSellVWR(false);
                setShowNegotiation(false);
                break;
            case 'Delete':
                let filterVehicles = [];
                filterVehicles = contextListVehicles.filter(
                    vehicle => vehicle.Id != selectedVehicle.Id
                );
                setSelectedVehicle(null);
                setContextListVehicles(filterVehicles);
                closeThisModal();
                break;
            default:
                closeThisModal();
                break;
        }
    };

    const closeThisModal = () => {
        disableHTMLOverflow(false);
        closeModal();
    };

    return (
        <Fragment>
            {possibleActions.length > 0 && showTakeDecision ? (
                <ModalTakeDecision
                    options={{ possibleActions }}
                    closeModal={closeModalTakeDecision}
                    EndDate = {selectedVehicle.EndDate}
                    importeIncentivo={selectedVehicle.ImporteIncentivoRecompraAC}
                    importeVMG={selectedVehicle.Price}
                    importeDaños={selectedVehicle.TotalDamageAmount}
                    AutoCredit={selectedVehicle.AutoCredit}
                />
            ) : null}
            {showNegotiation ? (
                <ModalNegotiateVehicle closeModal={closeModalTakeDecision} />
            ) : null}
            {showReject ? (
                <ModalRejectVehicle closeModal={closeModalTakeDecision} />
            ) : null}
            {showSellVWR ? (
                <ModalSellVWRVehicle closeModal={closeModalTakeDecision} />                
            ) : null}
        </Fragment>
    );
}

export default withCookies(DealerReceptorDecisions);
